import { render, staticRenderFns } from "./searchPlus.vue?vue&type=template&id=1a8870ab&scoped=true&"
import script from "./searchPlus.vue?vue&type=script&lang=js&"
export * from "./searchPlus.vue?vue&type=script&lang=js&"
import style0 from "./searchPlus.vue?vue&type=style&index=0&id=1a8870ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8870ab",
  null
  
)

export default component.exports